import axiosInstance from '../axiosInterceptor/axiosInstance'

const getStatsGameSetup = async ({ orgId, gameId, skipErrorNotification = false }) => {
  const url = `v1/orgs/${orgId}/stats/games/${gameId}/setup`
  const response = await axiosInstance.get(url, { skipErrorNotification })
  return response?.data
}

export default getStatsGameSetup
